<template>
  <v-dialog
    v-model="dialogFarms"
    width="500"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
    persistent
    content-class="access-modal"
  >
    <v-card tile>
      <v-card-text class="fill-height pa-0" style="background-color: #F6F6F6;">
        <v-toolbar card dark color="#3D495A">
          <v-toolbar-title>
            <v-list-tile-content>
              <v-list-tile-sub-title>Acessos</v-list-tile-sub-title>
              <v-list-tile-title class="text-capitalize">{{ user ? user.name : "" }}</v-list-tile-title>
            </v-list-tile-content>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>            
            <v-btn @click="dialogFarms = false" icon dark color="#545F6E">
              <v-icon>close</v-icon>
            </v-btn>            
          </v-toolbar-items>
        </v-toolbar>
        <v-layout style="height: calc(100% - 64px)" >
          <v-flex xs5 mt-1 pr-3 style="background-color: #fff; position: relative;">
            <v-fab-transition>
              <v-btn
                @click="setAllAccess(true, 'give')"
                small
                fab
                depressed
                bottom
                right
                color="primary"
                class="ma-0 btn-add-all-access"
                style="position: absolute;"
              >
                <v-icon>double_arrow</v-icon>
              </v-btn>
            </v-fab-transition>
            <v-fab-transition>
              <v-btn
                @click="setAllAccess(true, 'remove')"
                small
                fab
                depressed
                bottom
                right
                color="primary"
                class="ma-0 btn-remove-all-access"
                style="position: absolute;"
              >
                <v-icon>double_arrow</v-icon>
              </v-btn>
            </v-fab-transition>
            <div class="access-search-farm mb-0 mt-3 mx-3">
              <v-text-field
                outline
                single-line   
                label="Pesquisar"
                hint="Nome / Proprietário / Representante"
                prepend-inner-icon="search"
                persistent-hint
                clearable
                v-model="farms.without_access.term"
                @input="getFarmsWithoutAccess()"
              ></v-text-field>
            </div>
            <div class="body-2 grey--text mx-3">Sem acesso:</div>
            <v-flex
              class="mx-3 mt-1"
              style="height: 79%; overflow-y: auto;"
            >
              <v-flex v-show="farms.without_access.loading" class="access-loading mt-5 ma-auto">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="grey lighten-2"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
              <v-card
                @click="giveAccess(farm)"
                v-for="farm in farms.without_access.items"
                :key="farm.ref"
                color="#f6f6f6"
                class="mb-2 mr-2 c-pointer elevation-0"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card-title class="py-2 px-3">
                    <div>
                      <div class="title text-truncate" style="color: var(--font-color)">{{ farm.name }}</div>
                      <div class="body-1 grey--text pt-1 text-truncate">Proprietário - {{ farm.owner }}</div>
                      <div class="caption grey--text pt-1 text-truncate">Representante - {{ farm.representative }}</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div v-if="hover" style="overflow: hidden;">
                      <v-icon size="55" color="#EEE">double_arrow</v-icon>
                    </div>
                  </v-card-title>
                </v-hover>
              </v-card>
              <infinite-loading @infinite="infiniteHandlerWithoutAccess">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </v-flex>
          </v-flex>
          <v-flex xs7 pl-3>
            <div class="access-search-farm mb-0 mt-3 mx-3">
              <v-text-field
                outline
                single-line   
                label="Pesquisar"
                hint="Nome / Proprietário / Representante"
                prepend-inner-icon="search"
                persistent-hint
                clearable
                v-model="farms.with_access.term"
                @input="getFarmsWithAccess()"
              ></v-text-field>
            </div>
            <div class="body-2 grey--text mx-3">Com acesso:</div>
            <v-flex
              class="mx-3 mt-1"
              style="height: 79%; overflow-y: auto;"
            >
              <v-flex v-show="farms.with_access.loading" class="access-loading mt-5 ma-auto">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="grey lighten-2"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
              <v-card
                v-show="!farms.with_access.loading"
                v-for="farm in farms.with_access.items"
                :key="farm.ref"
                class="mb-2 mr-2 elevation-0"
              >
                <v-card-title class="py-2 px-3">
                  <div @click="farm.dialog = true" class="c-pointer" style="width: 55%;">
                    <div class="title text-truncate" style="color: var(--font-color)" :title="farm.name">{{ farm.name }}</div>
                    <div class="body-1 grey--text pt-1 text-truncate" :title="farm.owner">Proprietário - {{ farm.owner }}</div>
                    <div class="caption grey--text pt-1 text-truncate" :title="farm.representative">Representante - {{ farm.representative }}</div>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="access-permissions">
                    <div class="a-p-i pb-2 pt-1" text-xs-center>
                      <v-checkbox @change="setPermission(farm, 'view')" hide-details color="primary" class="ma-auto" v-model="farm.view"></v-checkbox>
                      <div class="a-p-i-t">Visualizar</div>
                    </div>
                    <div class="a-p-i pb-2 pt-1" text-xs-center>
                      <v-checkbox @change="setPermission(farm, 'edit')" hide-details color="primary" class="ma-auto" v-model="farm.edit"></v-checkbox>
                      <div class="a-p-i-t">Editar</div>
                    </div>
                    <div class="a-p-i pb-2 pt-1" text-xs-center>
                      <v-checkbox @change="setPermission(farm, 'add')" hide-details color="primary" class="ma-auto" v-model="farm.add"></v-checkbox>
                      <div class="a-p-i-t">Adicionar Visitas</div>
                    </div>
                  </div>
                  <div v-if="farm.dialog" class="access-permissions-dialog">
                    <v-layout fill-height wrap>
                      <v-flex @click="removeAccess(farm)" text-xs-center xs6 class="c-pointer">
                        <v-icon>remove_circle</v-icon><br/><span>REMOVER ACESSO</span>
                      </v-flex>
                      <v-flex @click="farm.dialog = false" text-xs-center xs6 class="c-pointer">
                        <v-icon>cancel</v-icon><br/><span>CANCELAR</span>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card-title>
              </v-card>
              <infinite-loading 
                v-show="!farms.with_access.loading"
                @infinite="infiniteHandlerWithAccess"
              >
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialogAllAccess.open"
      :persistent="dialogAllAccess.loading"
      content-class="o-visible"
      width="300"
    >
      <v-card
        color="blue-grey lighten-5"
      >
        <v-card-text class="pb-1">
          <v-flex v-if="dialogAllAccess.loading">
            Configurando acessos...
            <v-progress-linear
              indeterminate
              color="#3D495A"
            ></v-progress-linear>
          </v-flex>
          <v-flex v-else-if="!dialogAllAccess.loading">
            <b>{{ user ? user.name : '' }}</b><span v-if="dialogAllAccess.type == 'give'"> terá permissão de visualização em todas propriedades.</span><span v-if="dialogAllAccess.type == 'remove'"> terá todos acessos de visualização removidos, restando os de editar a propriedade e adicionar visitas.</span>
            <v-flex class="mt-1">
              <v-btn @click="dialogAllAccess.open = false" small outline class="mx-0" color="grey darken-1" style="min-width: 60px;">
                <v-icon>close</v-icon>
              </v-btn>
              <v-btn @click="setAllAccess(false)" small outline class="px-0 mr-0" color="indigo" style="width: 199px; float: right;">Confirmar</v-btn>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import {_} from 'vue-underscore'
import { debounce } from 'debounce'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    InfiniteLoading
  },
  data: () => ({
    dialogFarms: false,
    dialogAllAccess: {
      open: false,
      loading: false,
      type: null,
    },
    user: null,
    farms: {
      with_access: {
        loading: true,
        items: [],
        term: null,
        pages: 0,
        page: 1
      },
      without_access: {
        loading: true,
        items: [],
        term: null,
        pages: 0,
        page: 1
      }
    }
  }),
  methods: {
    openDialog(user) {
      this.user        = user
      this.dialogFarms = true
      this.getFarmsWithAccess()
      this.getFarmsWithoutAccess()
    },
    giveAccess(farm) {
      var self      = this
      var farmIndex =_.findIndex(self.farms.without_access.items, farm)
      self.$http.post('/v1/adm/access/with/farm/'+farm.ref, {
        params: {
          user: self.user.ref
        }
      }).then(function () {
        self.getFarmsWithAccess()
        self.$delete(self.farms.without_access.items, farmIndex)
      })
    },
    removeAccess(farm) {
      var self      = this
      var farmIndex =_.findIndex(self.farms.with_access.items, farm)
      self.$http.post('/v1/adm/access/without/farm/'+farm.ref, {
        params: {
          user: self.user.ref
        }
      }).then(function () {
        self.getFarmsWithoutAccess()
        self.$delete(self.farms.with_access.items, farmIndex)
      })
    },
    setPermission(farm, type) {
      var self = this
      self.$http.post(`/v1/adm/access/farm/${farm.ref}/permission`, {
        params: {
          user: self.user.ref,
          type: type,
          permission: farm[type]
        }
      })
    },
    setAllAccess(modal, type) {
      const self = this
      if (modal) {
        self.dialogAllAccess.type = type
        self.dialogAllAccess.open = true
      } else {
        self.dialogAllAccess.loading = true
        self.$http.post(`/v1/adm/access/${self.dialogAllAccess.type}/all`, {
          params: {
            user: self.user.ref
          }
        }).then(function () {          
          self.getFarmsWithAccess()
          self.getFarmsWithoutAccess()
          self.dialogAllAccess.open = false
          setTimeout(() => {
            self.dialogAllAccess.loading = false
          }, 300);
        }).catch(function () {
          self.dialogAllAccess.loading = false
        })
      }
    },
    getFarmsWithAccess: debounce(function () {
      const self = this
      self.farms.with_access.items = null
      self.farms.with_access.loading = true
      self.$http.get('/v1/adm/access/with/farm', {
        params: {
          page: 1,          
          user: self.user.ref,
          term: self.farms.with_access.term
        }
      }).then(function (r) {
        _.each(r.data.farms, function(f) {
          f.view   = JSON.parse(f.view)
          f.edit   = JSON.parse(f.edit)
          f.add    = JSON.parse(f.add)
          f.dialog = false
        })
        self.farms.with_access.pages   = r.data.pages
        self.farms.with_access.items   = r.data.farms
        self.farms.with_access.loading = false
      })
    }, 500),
    getFarmsWithoutAccess: debounce(function () {
      const self = this
      self.farms.without_access.items = null
      self.farms.without_access.loading = true
      self.$http.get('/v1/adm/access/without/farm', {
        params: {
          page: 1,
          user: self.user.ref,
          term: self.farms.without_access.term
        }
      }).then(function (r) {
        self.farms.without_access.pages   = r.data.pages
        self.farms.without_access.items   = r.data.farms
        self.farms.without_access.loading = false
      })
    }, 500),
    infiniteHandlerWithAccess($state) {
      const self = this
      self.farms.with_access.page += 1
      self.$http.get('/v1/adm/access/with/farm', {
        params: {
          page: self.farms.with_access.page,
          user: self.user.ref
        }
      }).then(function (r) {
        _.each(r.data.farms, function(f) {
          f.view   = JSON.parse(f.view)
          f.edit   = JSON.parse(f.edit)
          f.add    = JSON.parse(f.add)
          f.dialog = false
        })
        self.farms.with_access.items = _.union(self.farms.with_access.items, r.data.farms)
        if (r.data.page >= self.farms.with_access.pages) {
          $state.complete()
        } else {
          $state.loaded()
        }
      })
    },
    infiniteHandlerWithoutAccess($state) {
      const self = this
      self.farms.without_access.page += 1
      self.$http.get('/v1/adm/access/without/farm', {
        params: {
          page: self.farms.without_access.page,
          user: self.user.ref
        }
      }).then(function (r) {
        self.farms.without_access.items =  _.union(self.farms.without_access.items, r.data.farms)
        if (r.data.page >= self.farms.without_access.pages) {
          $state.complete()
        } else {
          $state.loaded()
        }
      })
    }
  },
  watch: {
    dialogFarms (val) {
      if (val == false) {
        this.farms = {
          with_access: {
            loading: true,
            items: [],
            term: null,
            pages: 0,
            page: 1
          },
          without_access: {
            loading: true,
            items: [],
            term: null,
            pages: 0,
            page: 1
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.access-modal {
  .access-search-farm {
    height: 76px;

    .v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot { min-height: 43px; }
    .v-text-field.v-text-field--enclosed .v-input__prepend-inner { margin-top: 8px; padding-right: 10px; }
    .v-text-field--box .v-label, .v-text-field--full-width .v-label, .v-text-field--outline .v-label { top: 10px; }
    .v-text-field.v-text-field--enclosed .v-input__append-inner { margin-top: 8px; }
    .v-text-field--box.v-text-field--single-line input, .v-text-field--full-width.v-text-field--single-line input, .v-text-field--outline.v-text-field--single-line input { margin-top: 4px; }

    .v-messages__message {
      text-align: right !important;
    }
  }

  .access-permissions {
    background-color: #f6f6f6;
    width: 300px;
    border-radius: 3px;

    .a-p-i {    
      float: left;

      &:nth-child(1) {
        width: 100px;
      }

      &:nth-child(2) {
        width: 80px;
        border-left: 1px solid #e6e2e2;
        border-right: 1px solid #e6e2e2;
      }

      &:nth-child(3) {
        width: 120px;
      }

      .a-p-i-t {
        padding-top: 5px;
        color: #888;
        text-align: center;
      }
      
      .v-input--checkbox {
        width: 25px;
      }
    }
  }

  .access-permissions-dialog {
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
  
    .flex {
      padding-top: 20px;
      color: #757575;
      font-weight: bold;

      &:nth-child(1) {
        border-right: 1px solid rgba(61, 73, 90, 0.1);
      }

      &:nth-child(2) {
        border-right: 1px solid transparent;
      }

      &:hover {
        background: rgba(61, 73, 90, 0.1);
        border-right: 1px solid transparent;
      }
    }
  }

  .access-loading {
    width: 70px;
  }

  .btn-add-all-access {
    bottom: 65px !important;
    right: -20px;
  }

  .btn-remove-all-access {
    right: -20px;
    transform: rotate(180deg);
  }

  .v-card__title .title{
    padding-bottom: 1px;
  }
}
</style>
